// extracted by mini-css-extract-plugin
export var offlineNotificaton = "d8_J2";
export var offlineNotificaton__button = "d8_J5";
export var offlineNotificaton__header = "d8_J4";
export var offlineNotificaton__text = "d8_J6";
export var offlineNotificaton__withCookie = "d8_J3";